import type { MassMessage } from '@/modules/chatting/types.ts'
import type { BulkMessageResponseContent } from '@/modules/online-mass-messages/types.ts'

export function mapBulkMessageToMassMessage(
  bulkMessage: BulkMessageResponseContent,
): MassMessage {
  const medias = bulkMessage.message.currentSequence.messages[0]?.medias?.[0]
  const mediaTypes: { [key: string]: number } | null = medias?.mediaId
    ? {
        mediaId: medias.mediaId,
        sorting: medias?.sorting || 0,
      }
    : null

  return {
    id: bulkMessage.message.id,
    userId: 0,
    originalUserId: 0,
    date: bulkMessage.message.createdAt,
    text: bulkMessage.message.currentSequence.messages[0].text,
    giphyId: null,
    textCropped: bulkMessage.message.currentSequence.messages[0].text,
    isFree: false,
    sentCount: bulkMessage.message.totalSent || 0,
    viewedCount: 0,
    price: (
      bulkMessage.message.currentSequence.messages[0].price || 0
    ).toString(),
    canUnsend: bulkMessage.message.status === 'Pending',
    unsendSeconds: 0,
    isCanceled: bulkMessage.message.status === 'Cancelled',
    mediaTypes,
    hasError: false,
    purchasedCount: 0,
    canSendMessageToBuyers: bulkMessage.message.followUpEnabled,
    releaseForms: [],
  }
}
